module.exports = __webpack_public_path__ + "img/24 de octubre_Miniatura 3D de Terror.4e67effe.png";